module.exports = require('react-router');
module.exports.routerRedux = require('react-router-redux');



/*****************
 ** WEBPACK FOOTER
 ** ./~/dva/router.js
 ** module id = 310
 ** module chunks = 1
 **/